const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/**
 * Escapes text for use inside HTML or a quoted attribute (EN-1350).
 *
 * Use it wherever a name from a user, the database or a file goes into an
 * API that takes HTML, such as Leaflet's bindTooltip, bindPopup and
 * setContent, or a layer-control name. Ordinary names render unchanged.
 */
export function escapeHtml(value: string | number | null | undefined): string {
  return String(value ?? '').replace(/[&<>"']/g, (ch) => HTML_ESCAPES[ch]);
}
